var map = {
	"./amex.png": 2459,
	"./bancontact.png": 2460,
	"./mastercard.png": 2461,
	"./visa.png": 2462
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;



//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/assets ^\.\/.*\.png$
// module id = 2475
// module chunks = 0